import { render, staticRenderFns } from "./filters-button.vue?vue&type=template&id=0f6a0e50&scoped=true&"
import script from "./filters-button.vue?vue&type=script&lang=js&"
export * from "./filters-button.vue?vue&type=script&lang=js&"
import style0 from "./filters-button.vue?vue&type=style&index=0&id=0f6a0e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a0e50",
  null
  
)

export default component.exports